import { sendGetRequest, sendPostRequest } from "services/apiService";

interface LinkedInTokenResponse {
  readonly token: string;
  email?: string;
}

export const getLinkedInTokenApi = (
  code: string,
  state: string,
  redirectTo = "",
): Promise<APIResponse<LinkedInTokenResponse>> =>
  sendGetRequest<APIResponse<LinkedInTokenResponse>>(
    `/linkedin-auth/token?code=${code}&state=${state}&redirectTo=${redirectTo}`,
  );

interface PasswordResetParams {
  email: string;
  continueURL?: string;
}
const sendPasswordResetEmailApi = (
  email: string,
  continueURL?: string,
): Promise<APIResponse<IGenericAPIResponse>> =>
  sendPostRequest<PasswordResetParams, APIResponse<IGenericAPIResponse>>(
    "/user/reset-password",
    {
      email,
      continueURL,
    },
  );

export default { getLinkedInTokenApi, sendPasswordResetEmailApi };
